import { render, staticRenderFns } from "./shuzhiti.vue?vue&type=template&id=e378f83c&"
import script from "./shuzhiti.vue?vue&type=script&lang=ts&"
export * from "./shuzhiti.vue?vue&type=script&lang=ts&"
import style0 from "./shuzhiti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports